/**
 * @Author: Scott Fogelgren
 * @Date:   2019-02-06T23:59:31-05:00
 * @Email:  sfogelgren@comsearch.com
 * @Project: Project Insight
 * @Last modified by:   Scott Fogelgren
 * @Last modified time: 2019-04-01T11:33:20-04:00
 * @Copyright: // Copyright (c) 2019 Comsearch, Inc., All rights reserved
 */
import React from 'react'
import { Jumbotron } from 'reactstrap'

const ActivationPending = () => (

  <Jumbotron>
    <h3>{'Thanks you for registering for ComsearchConnect'}</h3>
    <p>{`Your account activation is pending. We will notify you by email once your account activation is complete.`}</p>
    <p>{'If you have any questions, please contact '}<a href='mailto:customersupport@comsearch.com' target='_blank' rel='noopener noreferrer'>{'customersupport@comsearch.com'}</a></p>
  </Jumbotron>

)

export default ActivationPending
